import FindingsList from './FindingsList';
import { listAllFindings } from '../../../services/securityhubApi';
import { inspectorEngine } from './engines/inspector';

// Amazon Inspector findings.
//
// The source is the UNIFIED inbox scoped to this engine, not inspectorApi's
// listInspectorFindings: /findings/all returns the NormalizedFinding shape the
// shared table renders (findingId / workflowStatus / lastObservedAt) and tags
// each row engine='inspector', which is what makes a row click open the Inspector
// detail body. The engine-native endpoint returns Inspector's own DTO, whose
// field names the table does not read.
//
// Consequence worth knowing: the status filter therefore speaks the NORMALIZED
// vocabulary (NEW/SUPPRESSED/RESOLVED), which the Inspector engine maps back to
// ACTIVE/SUPPRESSED/CLOSED server-side. Sending Inspector's own vocabulary here
// would be silently dropped for CLOSED and return every row unfiltered.
const inspectorSource = (filters) => listAllFindings({ ...filters, engine: ['inspector'] });

// Accent and icon come from the engine descriptor rather than local constants so
// this page cannot drift from the sidebar entry and the Overview tile.
const InspectorIcon = inspectorEngine.Icon;

export default function InspectorFindings() {
  return (
    <FindingsList
      source={inspectorSource}
      engineKind="inspector"
      subtitle="Inspector findings"
      color={inspectorEngine.color}
      icon={<InspectorIcon sx={{ fontSize: 24 }} />}
    />
  );
}
